import { useInfiniteQuery } from "react-query";
import axios from "axios";

const getReceivedPostsByPortfolio = async (...args) => {
  let {
    companyIds,
    postSectionsFilter,
    pageParam,
    limit,
    portfolioId,
  } = args[0];

  let pathAndHost = window.location.protocol + window.location.host;

  let url = new URL(
    `/api/v2/portfolios/${portfolioId}/received_posts`,
    pathAndHost
  );

  if (companyIds && companyIds.length) {
    url.searchParams.append("company_ids", companyIds.join(","));
  }

  if (postSectionsFilter && postSectionsFilter.length > 0) {
    url.searchParams.append("post_sections", postSectionsFilter.join(","));
  }

  if (pageParam && pageParam > -1) {
    url.searchParams.append("offset", pageParam);
  }

  if (limit && limit > -1) {
    url.searchParams.append("limit", limit);
  }

  const { data: posts } = await axios.get(url.href);

  return posts;
};
export default function useReceivedPostsByPortfolio({
  companyIds,
  portfolioId,
  postSectionsFilter,
  limit,
}) {
  return useInfiniteQuery(
    [
      "portfolios",
      portfolioId,
      "received_posts",
      {
        // portfolioId,
        companyIds,
        postSectionsFilter,
        limit,
      },
    ],
    async ({ pageParam }) => {
      return await getReceivedPostsByPortfolio({
        portfolioId,
        companyIds,
        postSectionsFilter,
        limit,
        pageParam,
      });
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        let count = allPages.map((post) => post.data).flat().length;
        return count < lastPage.pagination.count ? count : false;
      },

      enabled: !!(useReceivedPostsByPortfolio && companyIds && portfolioId),
    }
  );
}